// import React, { useEffect, useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import "slick-carousel/slick/slick.css";
// import "slick-carousel/slick/slick-theme.css";
// import search from "../../../images/search.svg";

// import MobileLeftPart from "../casinoLeft/MobileLeftPart";
// import { selectUser, setLoginModal } from "../../../store/auth-slice";
// import { useDispatch, useSelector } from "react-redux";
// import { GameModes } from "../../../config";
// import { toastService } from "../../notificationPage/ToastContainer";
// import { GameCard } from "./GameCard";

// const CasinoCenter = ({ games, onGameClick, isVirtual = false }) => {
//   const [currentPage, setCurrentPage] = useState(1);
//   const user = useSelector(selectUser);
//   const [searchTerm, setSearchTerm] = useState("");
//   const [filteredGames, setFilteredGames] = useState([]);
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const itemsPerPage = 18; // Adjust based on your needs

//   useEffect(() => {
//     const filtered = Object.entries(games || {}).filter(([alias, game]) => {
//       const gameNameToSearch = game.gameName || alias;
//       return gameNameToSearch.toLowerCase().includes(searchTerm.toLowerCase());
//     });
//     setFilteredGames(filtered);
//     setCurrentPage(1); // Reset to first page when search changes
//   }, [searchTerm, games]);

//   // Calculate total pages
//   const totalPages = Math.ceil(filteredGames.length / itemsPerPage);

//   // Get current games for pagination
//   const getCurrentGames = () => {
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = startIndex + itemsPerPage;
//     return filteredGames.slice(startIndex, endIndex);
//   };

//   useEffect(() => {
//     // Reset to first page when games change
//     setCurrentPage(1);
//   }, [games]);

//   // Handle page change
//   const handlePageChange = (pageNumber) => {
//     setCurrentPage(pageNumber);
//     // Scroll to top of grid when page changes
//     window.scrollTo({ top: 0, behavior: "smooth" });
//   };

//   const handlePlayGame = (provider, alias, mode) => {
//     if (mode === GameModes.REAL && !user) {
//       dispatch(setLoginModal(true)); // Open login modal
//       toastService.error("Error! Please login to proceed!!");

//       return; // Stop further execution
//     }
//     // Navigate to the game page with query parameters
//     if (isVirtual) {
//       navigate(`/game/${alias}?provider=${provider}&mode=${mode}`);
//     } else {
//       navigate(`/game/${alias}?provider=${provider}&mode=${mode}`);
//     }
//   };
//   return (
//     <div className="bg-teal p-5 md:p-3 s15:p-5 md:rounded-md shadow-inputshadow">
//       {/* search */}
//       <div className="relative rounded-md shadow-inputshadow inputshadow mb-3 s15:mb-5">
//         <input
//           type="text"
//           className="p-[8px_40px_8px_8px] s18:p-[12px_40px_12px_12px] rounded-md w-full text-xs lg:text-sm s18:text-base font-normal placeholder:text-white/30 bg-white/10 text-white "
//           placeholder="Search Games.."
//         />
//         <img
//           src={search}
//           alt="search"
//           className="absolute top-1/2 -translate-y-1/2 right-4 invert"
//         />
//       </div>
//       {/* all games */}
//       <div>
//         <p className="text-darkblue dark:text-white text-sm lg:text-base s15:text-lg font-bold mb-3 s15:mb-5">
//           {isVirtual ? "Virtual Games" : "all games"}
//         </p>
//         <div className="grid grid-cols-4 md:grid-cols-6 gap-2 md:gap-3 s18:gap-[17px] place-content-center ">
//           {getCurrentGames().map(([alias, game]) => (
//             <GameCard
//               key={alias}
//               alias={alias}
//               imagePath={game.imagePath}
//               gameName={game.gameName || alias}
//               isVirtual={isVirtual}
//               provider={game.provider}
//               onPlay={(mode) => handlePlayGame(game.provider, alias, mode)}
//             />
//           ))}
//           {/* {images.map((image, index) => (
//             <Link to={image.url} key={index} className="rounded xl:rounded-md">
//               <img
//                 src={image.src}
//                 alt={`c${index + 1}`}
//                 className="object-contain rounded xl:rounded-md"
//               />
//             </Link>
//           ))} */}
//         </div>
//       </div>
//     </div>
//   );
// };

// export default CasinoCenter; isVirtual = false
import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Import icons (you'd need to replace these with your actual icons)
import searchIcon from "../../../images/search.svg";
import fireIcon from "../../../images/fire.svg";
import crashIcon from "../../../images/crash.svg";
import virtualsIcon from "../../../images/virtuals.svg";
import liteIcon from "../../../images/lite.svg";
import dropsIcon from "../../../images/drops.svg";
import slotsIcon from "../../../images/slots.svg";
import tableIcon from "../../../images/table.svg";
import liveIcon from "../../../images/live.svg";
import { GameCard } from "./GameCard";
import { setLoginModal } from "../../../store/auth-slice";
import { GameModes } from "../../../config";
import { toastService } from "../../notificationPage/ToastContainer";

const CasinoCenter = ({ games = {}, isVirtual = false }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredGames, setFilteredGames] = useState([]);
  const [activeCategory, setActiveCategory] = useState("All");
  const [activeProvider, setActiveProvider] = useState("All");
  const [showMobileFilters, setShowMobileFilters] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const itemsPerPage = 18;

  // Calculate total pages
  const totalPages = Math.ceil(filteredGames.length / 2);
  // const totalPages = Math.ceil(filteredGames.length / itemsPerPage);
  useEffect(() => {
    const filtered = Object.entries(games || {}).filter(([alias, game]) => {
      const gameNameToSearch = game.gameName || alias;
      return gameNameToSearch.toLowerCase().includes(searchTerm.toLowerCase());
    });
    setFilteredGames(filtered);
    setCurrentPage(1); // Reset to first page when search changes
  }, [searchTerm, games]);
  // Get current games for pagination
  const getCurrentGames = () => {
    // const startIndex = (currentPage - 1) * itemsPerPage;
    // const endIndex = startIndex + itemsPerPage;
    // return filteredGames.slice(startIndex, endIndex);
    return filteredGames;
  };

  // Handle page change
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // const handlePlayGame = (provider, gameId, mode = "demo") => {
  //   if (mode === "real" && !user) {
  //     // Handle login requirement
  //     dispatch(setLoginModal);
  //     // Show toast notification
  //     console.log("Please login to play for real money");
  //     return;
  //   }

  //   // Navigate to game page
  //   navigate(`/game/${gameId}?provider=${provider}&mode=${mode}`);
  // };
  const handlePlayGame = (provider, alias, mode) => {
    if (mode === GameModes.REAL && !user) {
      dispatch(setLoginModal(true)); // Open login modal
      toastService.error("Error! Please login to proceed!!");

      return;
    }
    if (user && user.balance < 0) {
      toastService.error("Error! Please Deposit to proceed!!");

      return;
    }
    // Navigate to the game page with query parameters
    if (isVirtual) {
      navigate(`/game/${alias}?provider=${provider}&mode=${mode}`);
    } else {
      navigate(`/game/${alias}?provider=${provider}&mode=${mode}`);
    }
  };

  return (
    <>
      {/* <div className="bg-darkGreen min-h-screen">
    
  <div className="max-w-[1760px] mx-auto px-4 py-6"> */}

      {/* Search bar */}
      <div className="relative mb-4">
        <input
          type="text"
          className="w-full p-3 pl-10 bg-[#0B1E21] text-white rounded-md placeholder-white/50 focus:outline-none"
          placeholder="Search Games..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
          <svg
            className="h-5 w-5 text-white/50"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z"
              clipRule="evenodd"
            />
          </svg>
        </div>
      </div>

      {/* Games grid */}
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-2 md:gap-3 s18:gap-[17px] px-5">
        {getCurrentGames().map(([alias, game]) => {
          return (
            <GameCard
              key={alias}
              alias={alias}
              game={game}
              imagePath={game.imagePath}
              gameName={game.name || alias}
              isVirtual={isVirtual}
              provider={game.provider}
              onPlay={(mode) => handlePlayGame(game.provider, alias, mode)}
            />
          );
        })}
      </div>

      {/* Pagination */}
      {/* {totalPages > 1 && (
        <div className="flex justify-center mt-6">
          <div className="flex space-x-2">
            <button
              onClick={() => handlePageChange(Math.max(1, currentPage - 1))}
              disabled={currentPage === 1}
              className={`px-3 py-1 rounded-md ${
                currentPage === 1
                  ? "bg-gray-700 text-gray-400 cursor-not-allowed"
                  : "bg-teal text-white hover:bg-darkGreen"
              }`}
            >
              &lt;
            </button>
            {[...Array(Math.min(5, totalPages))].map((_, i) => {
              let pageNum;
              if (totalPages <= 5) {
                pageNum = i + 1;
              } else if (currentPage <= 3) {
                pageNum = i + 1;
              } else if (currentPage >= totalPages - 2) {
                pageNum = totalPages - 4 + i;
              } else {
                pageNum = currentPage - 2 + i;
              }

              return (
                <button
                  key={i}
                  onClick={() => handlePageChange(pageNum)}
                  className={`px-3 py-1 rounded-md ${
                    currentPage === pageNum
                      ? "bg-darkGreen text-white"
                      : "bg-teal text-white hover:bg-darkGreen/80"
                  }`}
                >
                  {pageNum}
                </button>
              );
            })}
            <button
              onClick={() =>
                handlePageChange(Math.min(totalPages, currentPage + 1))
              }
              disabled={currentPage === totalPages}
              className={`px-3 py-1 rounded-md ${
                currentPage === totalPages
                  ? "bg-gray-700 text-gray-400 cursor-not-allowed"
                  : "bg-teal text-white hover:bg-darkGreen"
              }`}
            >
              &gt;
            </button>
          </div>
        </div>
      )} */}
    </>
    //   </div>
    // </div>
  );
};

export default CasinoCenter;
